import React, { useState, useEffect } from "react";
import { Container, Row } from "react-bootstrap";
import PageHeader from "../../Component/PageHeader";
import JobVacancyList from "./JobVacancyList";
import { useTranslation } from "react-i18next";

const JobList = () => {
  const { t } = useTranslation("translation");
  document.title = t("managejob.danhsachcongviec");

  let [paramSearch, setParamSearch] = useState();

  useEffect(() => {
    let data = { name: '', countryid: { value: 1, label: '' }, industry: { value: 1, label: '' } };
    setParamSearch(data);
  }, [])

  return (
    <React.Fragment>
      <PageHeader title="Danh sách công việc" />
      <section className="section">
        <Container fluid>
          <Row className="justify-content-center">
            {paramSearch && <JobVacancyList data={paramSearch} />}
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default JobList;
